<template>
	<div class="settings-content">
		<template v-if="soft_organigram.is_active">
			<template v-if="loaded">
				<div class="opacity-page">
					<div class="list-crud row-space-tbf">
						<div class="space-left"></div>
						<div class="content">
							<div class="list">
								<div class="item" v-for="workstation in workstations" @click="viewItem(workstation)" v-bind:class="{active: workstationSelected.id == workstation.id}">
									<div class="name">{{ workstation.name }}</div>
									<div class="actions">
										<button @click.stop="editItem(workstation)"><icon-edit /></button>
										<button @click.stop="showModal('delete', {type: 'work_station', from: 'index_work_stations', model: workstation})"><icon-trash /></button>
									</div>
								</div>
								<div class="item-empty" v-if="!workstations.length">
									{{ $t('workstations.no-result') }}
								</div>
							</div>
							<div class="crud" id="list-items">
								<div class="box" v-if="viewCrud == 'create'">
									<div class="header">
										<div class="icon-header"><icon-building /></div>
										<div class="name">{{ $t('workstations.create-new-workstation') }}</div>
									</div>
									<div class="form">
										<div class="input-group mb-15">
											<div class="label-header">
												<label class="label">{{ $t('general.name') }}*</label>
												<div v-if="$v.name.$error" class="error-msg">{{ $t('validator.required') }}</div>
												<div v-if="errorsBe.name" class="error-msg">{{ errorsBe.name.join(" | ") }}</div>
											</div>
											<div class="input-box bg-white" v-bind:class="{has_error: $v.name.$error}">
												<div class="icon-right" v-if="name != ''" @click.stop="name = ''"><icon-close class="icon-clear" /></div>
												<input type="text" :placeholder="$t('workstations.name-ph')" class="input-text no-icon" v-model="name">
											</div>
										</div>

										<div class="input-group">
											<div class="label-header">
												<label class="label">{{ $t('general.description') }}</label>
											</div>
											<div class="input-box bg-white">
												<textarea rows="3" :placeholder="$t('workstations.description-ph')" v-model="description"></textarea>
											</div>
										</div>

										<div class="form-submit">
											<div class="error-msg-settings" v-show="error_message != ''">{{error_message}}</div>
											<button id="buttonCreate" class="btn-tbf blue" @click="saveAction('create')">
												<div class="loader"></div>
												<span class="text">{{ $t('general.add') }}</span>
											</button>
										</div>
									</div>
								</div>
								<div class="box bg-white" v-else-if="viewCrud == 'edit'">
									<div class="header">
										<div class="icon-header"><icon-building /></div>
										<div class="name">{{ workstationSelected.name }}</div>
										<div class="action-close">
											<button class="btn-tbf white only-icon" @click="resetToList('item')">
												<div class="icon"><icon-close /></div>
											</button>
										</div>
									</div>
									<div class="form">
										<div class="input-group mb-15">
											<div class="label-header">
												<label class="label">{{ $t('general.name') }}*</label>
											</div>
											<div class="input-box" v-bind:class="{has_error: $v.name.$error}">
												<div class="icon-right" v-if="name != ''" @click.stop="name = ''"><icon-close class="icon-clear" /></div>
												<input type="text" :placeholder="$t('workstations.name-ph')" class="input-text no-icon" v-model="name">
											</div>
										</div>

										<div class="input-group">
											<div class="label-header">
												<label class="label">{{ $t('general.description') }}</label>
											</div>
											<div class="input-box">
												<textarea rows="3" :placeholder="$t('workstations.description-ph')" v-model="description"></textarea>
											</div>
										</div>

										<div class="form-submit">
											<div class="error-msg-settings" v-show="error_message != ''">{{error_message}}</div>
											<button id="buttonUpdate" class="btn-tbf blue" @click="saveAction('update')">
												<div class="loader"></div>
												<span class="text">{{ $t('general.update') }}</span>
											</button>
										</div>
									</div>
								</div>
								<div class="box bg-white" v-else-if="viewCrud == 'view'">
									<div class="header">
										<div class="icon-header"><icon-building /></div>
										<div class="name">{{ workstationSelected.name }}</div>
										<div class="action-close">
											<button class="btn-tbf blue only-icon" @click="editItem(workstationSelected)">
												<div class="icon"><icon-edit /></div>
											</button>
											<button class="btn-tbf white only-icon" @click="resetToList('item')">
												<div class="icon"><icon-close /></div>
											</button>
										</div>
									</div>
									<div class="data-item">
										<div class="description">{{ workstationSelected.description }}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="space-right"></div>
					</div>
				</div>
			</template>
			<loader-settings-page v-else/>
		</template>
		<template v-else>
			<div class="row-space-tbf">
				<div class="space-left"></div>
				<div class="content">
					<not-module class="with-border-top" />
				</div>
				<div class="space-right"></div>
			</div>
		</template>
	</div>
</template>

<script>
	import NotModule from '@/components/General/NotModule'
	import IconClose from '../../Icons/Close'
	import IconEdit from '../../Icons/Edit'
	import IconTrash from '../../Icons/Trash'
	import IconBuilding from '../../Icons/Building'
	import LoaderSettingsPage from '../../PagesLoaders/SettingsPage'
	import { required } from 'vuelidate/lib/validators'

	export default {
		components: {
			NotModule,
			IconClose,
			IconEdit,
			IconTrash,
			IconBuilding,
			LoaderSettingsPage
		},
		data() {
			return {
				loaded: false,
				viewCrud: 'create',
				workstations: [],
				workstationSelected: '',
				name: '',
				description: '',
				error_message: '',
				errorsBe: {}
			}
		},
		computed: {
			soft_organigram() {
				return this.$store.getters['applications/getApplication']('Organigrama');
			}
		},
		async mounted(){
			if( this.soft_organigram.is_active ){ 
				await this.getWorkstations()
			}

			setTimeout(() => {
				var title = this.$t('settings-navbar.workstations');
				this.$root.$emit("navbar_title", title);
			}, 0)

			this.$root.$on('refreshWorkStationsIndex', () => {
				this.viewCrud = 'create'
				this.getWorkstations()
			})

			if(!this.$auth.user().rights.admins_instance_crud){
				this.$router.push({name: 'forbbiden'})
			}
		},
		validations: {
			name: {required}
		},
		methods: {
			async getWorkstations(){
				await axios.get(this.$auth.user().instance.id + '/workstations')
				.then(({data}) => {
					this.workstations = data.data
				}).catch(error => {
					if(error.response) {
						if(error.response.status == 500) {
							alert(this.$t('error.500'))
						}
					}
				})
				.finally(() => {
					this.loaded = true
					setTimeout(() => {
						$('.opacity-page').addClass('show')
					}, 0)
				})
			},
			saveAction(type){
				var buttonName = `button${ type == 'create' ? 'Create' : 'Update'}`
				var btnSubmit = document.getElementById(buttonName)
				var btnSubmitLoader = document.querySelector(`#${buttonName} .loader`)
				var btnSubmitText = document.querySelector(`#${buttonName} .text`)
				btnSubmit.disabled = true
				btnSubmit.classList.add('loading')
				btnSubmitLoader.classList.add('onProgress')
				btnSubmitText.innerHTML = this.$t('btn-submit.loading')
				this.error_message = '';

				this.$v.$touch()
				if(!this.$v.$invalid){
					var objData = {
						name: this.name.charAt(0).toUpperCase() + this.name.slice(1),
						description: this.description
					}

					if(type == 'create'){
						this.createWorkStation(objData, btnSubmit, btnSubmitText, btnSubmitLoader)
					}else if(type == 'update'){
						this.updateWorkstation(objData, btnSubmit, btnSubmitText, btnSubmitLoader)
					}

				}else{
					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.error')
						btnSubmit.classList.add('error')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('error')
							btnSubmitText.innerHTML = type == 'create' ? this.$t('general.add') : this.$t('general.update')
							btnSubmit.disabled = false
						}, 1000)
					}, 300)
				}
			},
			createWorkStation(objData, btnSubmit, btnSubmitText, btnSubmitLoader){
				axios.post('/workstations/store', objData)
				.then(({data}) => {
					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.success')
						btnSubmit.classList.add('completed')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						this.getWorkstations()
						this.$v.$reset()
						setTimeout(()=>{
							this.resetToList()
							btnSubmit.classList.remove('completed')
							btnSubmitText.innerHTML = this.$t('general.add')
							this.workstationSelected = data.data;
							this.viewCrud = 'view'
						}, 1000)
					}, 300)
				})
				.catch(error => {
					btnSubmitLoader.classList.add('finish')
					this.errorsBe = error.response.data.errors
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.error')
						btnSubmit.classList.add('error')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('error')
							btnSubmitText.innerHTML = this.$t('general.add')
							btnSubmit.disabled = false
							if(error.response.status == 500){
								this.error_message = this.$t('error.500')
							}
						}, 1000)
					}, 300)
				})
				.finally(() => {
					setTimeout(()=>{
						btnSubmit.disabled = false
					}, 1500)
				})
			},
			updateWorkstation(objData, btnSubmit, btnSubmitText, btnSubmitLoader){
				axios.patch(`/workstations/${this.workstationSelected.id}`, objData)
				.then(({data}) => {
					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.success')
						btnSubmit.classList.add('completed')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						this.getWorkstations()
						this.$v.$reset()
						setTimeout(()=>{
							this.resetToList()
							btnSubmit.classList.remove('completed')
							btnSubmitText.innerHTML = this.$t('general.add')
							this.workstationSelected = this.workstations.find(el => el.id == this.workstationSelected.id)
							this.viewCrud = 'view'
						}, 1000)
					}, 300)
				})
				.catch(error => {
					btnSubmitLoader.classList.add('finish')
					this.errorsBe = error.response.data.errors
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.error')
						btnSubmit.classList.add('error')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('error')
							btnSubmitText.innerHTML = this.$t('general.update')
							btnSubmit.disabled = false
							if(error.response.status == 500){
								this.error_message = this.$t('error.500')
							}
						}, 1000)
					}, 300)
				})
				.finally(() => {
					setTimeout(()=>{
						btnSubmit.disabled = false
					}, 1500)
				})
			},
			editItem(workstation){
				this.scrollTop()
				this.viewCrud = 'edit'
				
				this.workstationSelected = workstation

				this.name = workstation.name
				this.description = workstation.description
			},
			showModal(type, data = false, itemId = false){
				this.$root.$emit('open_modal', type, data, itemId);
			},
			resetToList(from){
				this.viewCrud = 'create'
				if(from == 'item') {
					this.workstationSelected = ''
				}
				this.name = ''
				this.description = ''
			},
			viewItem(item){
				this.scrollTop()
				this.viewCrud = 'view'
				this.workstationSelected = item
			},
			scrollTop() {
				var top_value = {scrollTop:$('#list-items').position().top}
				if(top_value.scrollTop !== 135){
					$('div').animate({scrollTop:0}, 'slow');
				}
			}
		}
	};
</script>

<style lang="scss">
	
</style>